import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, defineProps, defineEmits } from "../TUIKit/adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import BottomPopup from "../TUIKit/components/common/BottomPopup";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfilePopup',
  props: {
    show: { type: Boolean, default: false },
    title: { default: "" }
  },
  emits: ["onClose", "onSubmit"],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, title: string }



function onClose() {
  emits("onClose");
}
function onSubmit() {
  emits("onSubmit");
}

return { __sfc: true,props, emits, onClose, onSubmit, TUITranslateService, BottomPopup }
}

})